export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  formValues: {
    age: null,
  },

  processFormValues() {
    return {
      age: parseInt(this.formValues.age),
    }
  },
})
